import { createFileRoute } from '@tanstack/react-router';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/about')({
  head: () => ({ meta: seo({ title: 'Rólunk' }) }),
  component: About
});

function About() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Rólunk</h1>
        <div className="row">
          <div className="col-lg-10 mb-3">
            <p>
              Mi a Pixwristnél hiszünk abban, hogy egyetlen apró gesztus, egy
              szó vagy egy kiegészítő is képes pozitív hatással lenni a
              mindennapokra. Azért alkottuk meg karkötőinket, hogy stílust,
              motivációt és egyedi üzeneteket hozzanak az életedbe.
            </p>
            <p>
              Minden karkötőnk egyedi mintázattal és inspiráló üzenettel készül,
              amelyek emlékeztetnek arra, hogy légy jelen, fókuszálj a
              céljaidra, és merj nagyot álmodni. Csak egy pillantás, és a
              karkötő ereje segít, hogy a pozitív gondolatok irányítsanak.
            </p>
            <p>
              Könnyű viseletüknek köszönhetően szinte észrevétlenül kísérnek
              végig a napodon, mégis folyamatos motivációt nyújtanak. Kétoldalas
              designjuk révén pedig minden alkalomhoz igazíthatod őket &ndash;
              legyen az sportos, elegáns, vagy éppen laza.
            </p>
            <p>
              Célunk, hogy mindig új és változatos mintákat kínáljunk, amelyek
              tükrözik az egyéniségedet, és minden nap egy kis pluszt adnak az
              életedhez.
            </p>
            <p>
              Válaszd a Pixwrist karkötőit, és légy részese egy pozitív és
              inspiráló közösségnek, ahol a szavak és a stílus találkoznak!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
